import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=ab3a209e&scoped=true"
import script from "./userAvatar.vue?vue&type=script&lang=js"
export * from "./userAvatar.vue?vue&type=script&lang=js"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=ab3a209e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a209e",
  null
  
)

export default component.exports